import { useAuth } from './useAuth';

export function useHasTenantPermission(permissionCode: string): boolean {
  const { tenantPermissions } = useAuth();
  return tenantPermissions.includes(permissionCode);
}
